<div *ngIf="office && office.media">
  <div class="flex align-items-start justify-content-between">
    <h3>Supports</h3>
    <button
      *ngIf="hasRole('db-edit-offices')"
      pButton
      label="Add Support"
      type="button"
      (click)="createClicked()"
      class="p-button-raised p-button-warning"
      icon="pi pi-plus-circle"
      style="margin-bottom: 10px"
    ></button>
  </div>
  <p-table
    class="media-supports-table"
    #dt
    styleClass="p-datatable-sm"
    [value]="office.media.supports"
    [loading]="isLoading"
    [scrollable]="true"
    selectionMode="single"
  >
    <ng-template pTemplate="caption">
      <div class="flex align-items-center justify-content-between"></div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th>Support</th>
        <th>Media Type</th>
        <th class="actions" *ngIf="hasRole('db-edit-offices')">Actions</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-support>
      <tr>
        <td>{{ support.name }}</td>
        <td>{{ support.type?.name }}</td>
        <td class="actions" *ngIf="hasRole('db-edit-offices')">
          <button
            pButton
            type="button"
            icon="pi pi-file-edit"
            class="p-button-outlined p-button-warning"
            (click)="editClicked($event, support)"
          ></button>
          <button
            pButton
            type="button"
            icon="pi pi-trash"
            class="p-button-outlined p-button-warning"
            (click)="confirmDelete($event, support)"
          ></button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="summary">
      <div class="flex align-items-center justify-content-between">
        In total there are {{ office.media.supports ? office.media.supports.length : 0 }} media supports.
      </div>
    </ng-template>
  </p-table>

  <p-toast></p-toast>
  <p-confirmPopup></p-confirmPopup>
</div>
